import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, DownloadIcon } from 'lucide-react';
const NAMES = ['James M.', 'Maria L.', 'Daniel R.', 'Sofia P.', 'Jack G.', 'Lucy T.', 'Michael A.', 'Eleanor V.', 'Andrew C.', 'Camilla F.'];
const STATUS_LABELS = ['Digital access', 'Purchase verified', 'New member', 'Guide downloaded'];
type Purchase = {
  name: string;
  status: string;
  time: string;
};
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState<Purchase>({
    name: '',
    status: '',
    time: ''
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout> | undefined;
    const showPurchase = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const status = STATUS_LABELS[Math.floor(Math.random() * STATUS_LABELS.length)];
      const minutes = Math.floor(Math.random() * 15) + 1;
      setCurrentPurchase({
        name,
        status,
        time: `${minutes} min ago`
      });
      setIsVisible(true);
      hideTimer = setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimer = setTimeout(showPurchase, 25000);
    const intervalTimer = setInterval(showPurchase, 65000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
      if (hideTimer) clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -20,
      y: 50
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 flex max-w-xs items-start gap-3 rounded-lg border border-stone-200 bg-white p-4 shadow-xl sm:bottom-6 sm:left-6 sm:max-w-sm" aria-live="polite" data-id="element-2">
          <div className="mt-0.5 flex-shrink-0 rounded-full bg-emerald-100 p-2" data-id="element-3">
            <CheckCircle2Icon className="h-5 w-5 text-emerald-600" aria-hidden="true" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-stone-900" data-id="element-6">
              {currentPurchase.name} just got the guide
            </p>
            <div className="mt-1 flex items-center gap-2 text-xs text-stone-500" data-id="element-7">
              <span className="flex items-center gap-1" data-id="element-8">
                <DownloadIcon className="h-3 w-3" aria-hidden="true" data-id="element-9" />
                {currentPurchase.status}
              </span>
              <span aria-hidden="true" data-id="element-10">•</span>
              <span data-id="element-11">{currentPurchase.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}